import React from 'react'
import logo from 'assets/icon.svg'

export interface IFleximeLoader {
  size: number
  style?: React.CSSProperties
}

export const FleximeLoader: React.FC<IFleximeLoader> = React.memo(({ size, style }) => {
  return (
    <div className="" style={style}>
      <img
        className="animate-spin"
        alt={'Loading'}
        src={logo}
        width={size}
        height={size}
      />
    </div>
  )
})
